import { render } from "./FieldGroupForm.vue?vue&type=template&id=15ad7f4c&ts=true"
import script from "./FieldGroupForm.vue?vue&type=script&lang=ts"
export * from "./FieldGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__